import { router } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props {
  // Rótulo do link (ex.: "Integrações", "Credenciais").
  label: string
  // Destino se não houver página anterior (carga direta por URL): a listagem.
  fallbackHref: string
  className?: string
}

/**
 * Botão "voltar" das páginas de detalhe. Vai para a PÁGINA ANTERIOR de verdade
 * (history.back), não para uma listagem fixa — então, vindo do painel do agente
 * (a aba Integrações/Credenciais dele), volta pra lá em vez de cair na listagem
 * da organização. Sem histórico (URL aberta direto) cai no fallback. Reusado por
 * integrações (provider/Composio) e credenciais.
 */
export function BackLink({ label, fallbackHref, className }: Props) {
  const hasSameOriginDashboardReferrer = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !document.referrer) return false

    try {
      const referrer = new URL(document.referrer)
      return referrer.origin === window.location.origin && referrer.pathname.startsWith('/dashboard')
    } catch {
      return false
    }
  }

  const goBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1 && hasSameOriginDashboardReferrer()) {
      window.history.back()
    } else {
      router.visit(fallbackHref)
    }
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className={cn(
        'inline-flex w-fit items-center gap-1.5 text-[13px] text-muted-foreground transition-colors hover:text-foreground',
        className,
      )}
    >
      <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.75} />
      {label}
    </button>
  )
}
